module.exports = __webpack_public_path__ + "img/FLSH10.d67f35a6.svg";